import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams, ToastController } from 'ionic-angular';
import { IngredientCompCreateInfoPage } from "../ingredient-comp-create/ingredient-comp-create-info/ingredient-comp-create-info";
import { IngredientCreateInfoPage } from "../ingredient-create/ingredient-create-info/ingredient-create-info";
import { IngredientsServices } from '../services';
import { Globals } from '../../../globals';
import { TranslateService } from '@ngx-translate/core';

/**
 * Generated class for the IngredientCreateSelectType page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-ingredient-create-select-type',
  templateUrl: 'ingredient-create-select-type.html',
})
export class IngredientCreateSelectType {

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public toastCtrl: ToastController,
    public ingredientsServices: IngredientsServices,
    public globals: Globals,
    public translate: TranslateService) {

  }

  openProductTitles(type) {
    this.globals.GAtrackView('Ingredients', 'Ingredients - Select type - Create', this.globals.restaurant.email, 'Create/Update', 'Create select type', 'Ingredients', type);
    if (type == 'foodcost') {
      this.navCtrl.push(IngredientCompCreateInfoPage, {
        type: type,
      });
    } else {
      if (this.ingredientsServices.quick_create_dish) {
        this.navCtrl.push(IngredientCreateInfoPage, {
          type: type,
        });
      } else {
        this.navCtrl.push(IngredientCreateInfoPage, {
          type: type,
        });
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/ingredients/ingredient-create-select-type/ingredient-create-select-type.ts